import type { FieldMatcher } from '@cdw-ae/filter-bar-interfaces';

export const StartsWithMatcher: FieldMatcher = {
  name: 'startsWith',
  displayName: 'Starts with',
  hasEditor: true,
  options: {
    chipFormatter: (value: string) => `: ${value}`,
  },
};